<template>
  <v-dialog
    :model-value="vaListModal"
    persistent
    max-width="600"
    class="bg-white"
  >
    <div class="rounded-md bg-white p-4">
      <slot name="title"></slot>
      <div
        v-if="checkoutStore.selectedRoles.length !== 0"
        class="grid grid-cols-3 p-5"
      >
        <p>Roles</p>
        <p>Hours</p>
        <p>VA Candidates</p>
        <div
          v-for="(role, index) of subscriptions"
          :key="index"
          class="col-span-4 grid grid-cols-3 py-2"
        >
          <div>
            <v-chip>
              <span class="truncate">{{ index }}</span></v-chip
            >
          </div>
          <p>{{ role.hours }}</p>
          <div class="-space-x-4">
            <img
              v-for="avatar_id of role.avatar_ids"
              :key="avatar_id"
              class="relative z-30 inline h-12 w-12 rounded-full border-2 border-white object-cover"
              :src="
                avatar_id === -1
                  ? '/img/Virtual-Gurus-Assistants-Color-Logo-mobile.png'
                  : getAvatar(avatar_id)
              "
              lazy-src="/img/profile.png"
              alt="Profile image"
            />
          </div>
        </div>
      </div>

      <div class="col-span-full flex flex-row justify-between gap-4">
        <vg-btn vg-type="tertiary" @click="revert"> cancel </vg-btn>
        <div class="lg:grow"></div>
        <vg-btn @click="remove"> accept </vg-btn>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';
import { API_URL } from '@/config';

export default {
  name: 'ClientVAList',
  props: {
    vaList: {
      type: Array,
      default: null,
    },
    vaListModal: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['remove', 'revert'],
  computed: {
    ...mapStores(useCheckoutStore),
    subscriptions() {
      return this.vaList.reduce((result, currentValue) => {
        const role =
          this.checkoutStore.allRoles?.find(
            (role) => role.id === currentValue.role_id
          )?.value ||
          this.checkoutStore.selectedRoles?.find(
            (role) => role.id === parseInt(currentValue.role_id)
          )?.value ||
          currentValue.role_id;

        if (!role) {
          return result;
        }

        result[role] = result[role] || {};
        result[role]['hours'] = currentValue.hours;
        result[role]['assistant_ids'] = result[role]['assistant_ids'] || [];
        result[role]['assistant_ids'].push(currentValue.assistant_id);
        result[role]['avatar_ids'] = result[role]['avatar_ids'] || [];
        result[role]['avatar_ids'].push(currentValue.avatar_id);

        return result;
      }, {});
    },
  },
  methods: {
    getAvatar(avatar_id) {
      return `${API_URL}/file/avatar/${avatar_id ? avatar_id : -1}`;
    },
    remove() {
      this.$emit('remove');
    },
    revert() {
      this.$emit('revert');
    },
  },
};
</script>
